// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__48W6n","Title":"Header_Title__w7IRB","SubTitle":"Header_SubTitle__eHJ5L","Back":"Header_Back__k7lEf"};